import { BrandConfig } from "../brand-config";
import { enoraBrand } from "./enora.brand";
import { rantalainenBrand } from "./rantalainen.brand";
import { testbrand } from "./testbrand.brand";

export const BRAND_REGISTRY: Record<string, BrandConfig> = {
  rantalainen: rantalainenBrand,
  enora: enoraBrand,
  testbrand: testbrand, // TODO: Remove if we don't want to have a test brand
};
